module.exports = __webpack_public_path__ + "static/media/selecteur2.c3bddf86.svg";